const modalsButtonStyles = () => {
    return {
        baseButton: {
            width: 'fit-content',
            minWidth: 80,
            height: 38,
            borderRadius: 0,
            fontWeight: 500,
            padding: '6px 14px',
            margin: '0 30px',
            boxShadow: 'none',
            '&:active': {
                animation: '$blink 0.5s'
            }
        },
        buttonsContainer: {
            marginTop: 24,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        cancelButton: {
            width: 'fit-content',
            minWidth: 80,
            height: 38,
            borderRadius: 0,
            fontWeight: 500,
            padding: '6px 14px',
            margin: '0 30px',
            boxShadow: 'none',
            border: '1px solid rgba(0, 0, 0, 0.87)',
            backgroundColor: 'transparent',
            color: 'rgba(0, 0, 0, 0.87)',
            '&:hover': {
                backgroundColor: 'transparent'
            },
            textTransform: 'none',
            fontSize: 14
        },
        confirmButton: {
            width: 'fit-content',
            minWidth: 80,
            height: 38,
            borderRadius: 0,
            fontWeight: 500,
            padding: '6px 14px',
            margin: '0 30px',
            boxShadow: 'none',
            backgroundColor: '#b41778',
            '&:hover': {
                backgroundColor: '#b41778'
            },
            color: 'white',
            border: 'none',
            textTransform: 'none',
            fontSize: 14
        },
        '@keyframes blink': {
            '0%': { filter: 'brightness(1.5)' },
            '50%': { filter: 'brightness(1.5)' },
            '100%': { filter: 'brightness(1)' }
        }
    };
};

const buttonsStyles = theme => ({
    grayButton: {
        backgroundColor: theme.palette.gray.bold,
        color: 'white',
        '&:hover': {
            backgroundColor: theme.palette.gray.bold
        }
    },
    redButton: {
        backgroundColor: 'red',
        textTransform: 'none',
        color: 'white',
        '&:hover': {
            backgroundColor: 'red'
        }
    },
    addCircleStyle: {
        fontSize: 30,
        color: '#2B78E4'
    }
});

// v2 customer app styles
const headerButtonStyles = () => ({
    primaryHeaderButton: {
        backgroundColor: '#000000',
        color: '#ffffff',
        borderRadius: '35px',
        fontFamily: 'Inter, sans-serif',
        fontWeight: 600,
        textTransform: 'none',
        fontSize: '14px',
        padding: '8px 16px',
        minWidth: 'auto',
        boxShadow: 'none',
        '&:hover': {
            backgroundColor: '#000000',
            boxShadow: 'none'
        },
        '&:disabled': {
            backgroundColor: '#cccccc',
            color: '#666666'
        }
    },
    secondaryHeaderButton: {
        backgroundColor: '#ffffff',
        color: '#000000',
        borderRadius: '35px',
        fontFamily: 'Inter, sans-serif',
        fontWeight: 600,
        textTransform: 'none',
        fontSize: '14px',
        padding: '8px 16px 8px 0',
        minWidth: 'auto',
        boxShadow: 'none',
        '&:hover': {
            backgroundColor: '#ffffff',
            boxShadow: 'none'
        },
        '&:disabled': {
            backgroundColor: '#f5f5f5',
            color: '#666666'
        }
    }
});

module.exports = {
    modalsButtonStyles,
    buttonsStyles,
    headerButtonStyles
};
